import { inject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-http-client';

@inject(HttpClient)
export class WhiteLabelWhiteLabelAdminAPI {
  constructor(http) {
    this.http = http;
  }

  save(data, files, token, successCallback, errorCallback) {
    let http = new HttpClient().configure(x => {
      x.withHeader('Authorization', token);
    });

    let formData = new FormData();
    formData.append('whitelabel', JSON.stringify(data));
  
    for(var [fileType, file] of files) {
      formData.append(fileType, file);
    }

    http.post('api/wladmin/whitelabel/save', formData)
        .then(data => {

            if (data.isSuccess) {
                if (data.response) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("whitelabel")) {
                       
                        successCallback(json.whitelabel);
                    }

                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);
                } else
                    successCallback();

            }
            else {
                errorCallback(data.statusText);
            }
        });
  }

  updateWlSubscription(data,token, successCallback, errorCallback) {
    let http = new HttpClient().configure(x => {
      x.withHeader('Authorization', token);
    });

    let formData = new FormData();
    formData.append('data', JSON.stringify(data));
  
 
    http.post('api/wladmin/whitelabel/updateSubscription', formData)
        .then(data => {

            if (data.isSuccess) {
                if (data.response) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("whitelabel")) {
                       
                        successCallback(json.whitelabel);
                    }

                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);
                } else
                    successCallback();

            }
            else {
                errorCallback(data.statusText);
            }
        });
  }

  create( data, token, successCallback, errorCallback) {
    this.http = this.http.configure(x => {
        x.withHeader('Content-Type', 'application/json')
       .withHeader('Authorization', token);
    });


    this.http.post('api/admin/whitelabel/create', data)
        .then(data => {

            if (data.isSuccess) {
                if (data.response) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("whitelabel_id")) {
                       
                        successCallback(json.whitelabel_id);
                    }


                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);
                } else
                    successCallback();

            }
            else {
                errorCallback(data.statusText);
            }
        });
  }


  getWhiteLabelDataById(id, token, successCallback, errorCallback) {
    this.http = this.http.configure(x => {
      x.withHeader('Content-Type', 'application/json')
       .withHeader('Authorization', token);
    });

    this.http.get('api/wladmin/whitelabel/getWhiteLabelDataById/' + id)
      .then(data => {
        if (data.isSuccess) {
          let json = JSON.parse(data.response);

          if (json.hasOwnProperty('whitelabel')) {
            successCallback(json.whitelabel);
          }

          if (json.hasOwnProperty('error')) {
            errorCallback(json.error);
          }
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  getWhiteLabelData(token, successCallback, errorCallback) {
    this.http = this.http.configure(x => {
      x.withHeader('Content-Type', 'application/json')
       .withHeader('Authorization', token);
    });

    this.http.get('api/wladmin/whitelabel/getWhiteLabelData')
      .then(data => {
        if (data.isSuccess) {
          let json = JSON.parse(data.response);

          if (json.hasOwnProperty('whitelabel')) {
            successCallback(json.whitelabel);
          }

          if (json.hasOwnProperty('error')) {
            errorCallback(json.error);
          }
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  getWhiteLabelStatusList(token, successCallback, errorCallback) {
    this.http = this.http.configure(x => {
      x.withHeader('Content-Type', 'application/json')
       .withHeader('Authorization', token);
    });

    this.http.get('api/admin/whitelabel/getWhiteLabelStatusList')
      .then(data => {
        if (data.isSuccess) {
          let json = JSON.parse(data.response);

          if (json.hasOwnProperty('whitelabelStatusList')) {
            successCallback(json.whitelabelStatusList);
          }

          if (json.hasOwnProperty('error')) {
            errorCallback(json.error);
          }
        } else {
          errorCallback(data.statusText);
        }
      });
  }
}
